export function createReminderSoundController(options) {
  const {
    audioFactory,
    documentRef = typeof document !== 'undefined' ? document : null,
    windowRef = typeof window !== 'undefined' ? window : null,
    logger = console,
    volume = 0.6
  } = options || {}

  let audio = null
  let unlockRegistered = false
  let unlocked = false

  function getAudio() {
    if (!audio && typeof audioFactory === 'function') {
      audio = audioFactory()
      if (audio) {
        audio.volume = volume
      }
    }
    return audio
  }

  function debug(message, error) {
    if (logger && typeof logger.debug === 'function') {
      logger.debug(message, error)
    }
  }

  function resetAudio(target) {
    try {
      target.currentTime = 0
    } catch (error) {
      debug('[reminderSound] reset currentTime failed', error)
    }
  }

  function playReminderSound() {
    const target = getAudio()
    if (!target || typeof target.play !== 'function') {
      return Promise.resolve(false)
    }
    resetAudio(target)
    return target.play()
      .then(() => true)
      .catch(error => {
        debug('[reminderSound] play blocked', error)
        return false
      })
  }

  function removeUnlockListeners() {
    if (!documentRef) return
    documentRef.removeEventListener('click', unlock, true)
    documentRef.removeEventListener('keydown', unlock, true)
    documentRef.removeEventListener('touchstart', unlock, true)
  }

  function unlock() {
    const target = getAudio()
    if (!target || typeof target.play !== 'function') {
      removeUnlockListeners()
      return Promise.resolve(false)
    }
    resetAudio(target)
    return target.play()
      .then(() => {
        if (typeof target.pause === 'function') {
          target.pause()
        }
        resetAudio(target)
        unlocked = true
        removeUnlockListeners()
        return true
      })
      .catch(error => {
        debug('[reminderSound] unlock blocked', error)
        return false
      })
  }

  function setupReminderSoundUnlock() {
    if (unlockRegistered || unlocked || !documentRef || !windowRef) {
      return
    }
    unlockRegistered = true
    documentRef.addEventListener('click', unlock, true)
    documentRef.addEventListener('keydown', unlock, true)
    documentRef.addEventListener('touchstart', unlock, true)
  }

  return {
    playReminderSound,
    setupReminderSoundUnlock,
    getAudio
  }
}
